import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@d-services';
import { AzureSSOService } from '@d-services/other/azure-sso.service';
import { AzureSSOModule } from '@d-shared/azure-sso.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-call-back',
  templateUrl: './call-back.component.html',
  styleUrls: ['./call-back.component.scss'],
  standalone: true,
  imports: [AzureSSOModule, ProgressSpinnerModule],
})
export class CallbackComponent implements OnInit {
  code: string;
  codeVerifier: string;
  state: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private azureSSOService: AzureSSOService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    const params = new URLSearchParams(this.route.snapshot.queryParams);
    this.code = params.get('code');
    this.state = params.get('state');
    // Get then remove code_verifier localstorage
    const codeVerifier = localStorage.getItem('code_verifier');
    this.codeVerifier = codeVerifier;

    localStorage.removeItem('code_verifier');
    if (!this.code || !this.codeVerifier) {
      this.router.navigateByUrl('/login');
      return;
    }
    this.azureSSOService
      .claimSSOToken(this.code, this.codeVerifier, this.state)
      .subscribe((res: any) => {
        const token = res.access_token;
        this.authService.loginSSO({ token }).subscribe(() => {
          window.location.href = '/home';
        });
      });
  }
}
